// Constants
import { t } from "i18next";

import { BOTTOM_MENU_LINKS } from "./constants";

// Style
import {
  Container,
  MenuButton,
  ActiveBorder,
  BottomMenuText,
  AlertCircle,
} from "./styles";
import { SVG } from "../ui/SVG";
import { SVGIcon } from "../ui/SVG/types";

export const BottomMenu = () => {
  return (
    <Container>
      {BOTTOM_MENU_LINKS.map((link) => {
        const {
          id: linkId,
          route,
          icon,
          title,

          label,
          alertPositionTop,
          alertPositionRight,
          hasActiveColorIcon,
          getCountQuery,
        } = link;

        function checkHasAlertCircle() {
          const { data } = getCountQuery
            ? (getCountQuery() as { data: { count: number } })
            : { data: { count: 0 } };
          return data?.count > 0;
        }

        return (
          <MenuButton
            key={`bottom-menu-${linkId}`}
            to={route}
            activeclassname="active"
            data-heap={`bottom-menu-${linkId}-button`}
            title={String(t(title))}
            className={linkId}
            activeColorIcon={hasActiveColorIcon}>
            <SVG icon={icon as SVGIcon} svgProp={{ width: 18 }} />
            <BottomMenuText>{t(label)}</BottomMenuText>

            {checkHasAlertCircle() ? (
              <AlertCircle top={alertPositionTop} right={alertPositionRight} />
            ) : null}
            <ActiveBorder />
          </MenuButton>
        );
      })}
    </Container>
  );
};
